import SiafLiteApiRepository from "../../external/siafLiteApi";

class ConfiguracoesChecklistService {
  constructor() {
    this.urlBase = "/faturamento/configuracoes-checklist";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll() {
    return new SiafLiteApiRepository(this.urlBaseEvent).get();
  }

  upsert(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }
}

export default ConfiguracoesChecklistService;
